import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import * as moment from 'moment';

export class HelperService {
  static debounce = (func, delay = 3000) => {
    let debounceTimer;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func.apply(context, args), delay);
      };
  }
  static copyObj(obj = {}) {
    return _.cloneDeep(obj);
  }
  static getQueryString(find: any = {}, select: any = []) {
      const keywords = Object.keys(find);
      const specialOperator = [
        'sort',
        'limit',
        'offset',
      ];
      let queryString = keywords.reduce((acc, keyword, index) => {
        if (keyword === 'status' && find[keyword] === 'all') {
          acc = acc;
          return acc;
        }
        const findCondition = find[keyword];
        if (specialOperator.includes(keyword)) {
          acc += `${keyword}=${findCondition}`;
        } else if (findCondition instanceof Array) {
          acc += `${keyword}__in=${findCondition.join(',')}`;
        } else if (typeof findCondition === 'object' ) {
          acc += this.makeConditionQuery(keyword, findCondition);
        } else {
          acc += `${keyword}__eq=${findCondition}`;
        }
        acc += `&`;
        return acc;
      }, '');
      if (select && select.length) {
        queryString += `select=${select.join(',')}`;
      }
      return queryString;
  }
  static queryString(query: any = {}) {
    const keywords = Object.keys(query);
    const queryString = keywords.reduce((acc, keyword) => {
      const findCondition = query[keyword];
      // if (specialOperator.includes(keyword)) {
      //   acc += `${keyword}=${findCondition}`;
      // } else if (findCondition instanceof Array) {
      //   acc += `${keyword}__in=${findCondition.join(',')}`;
      // } else if (typeof findCondition === 'object' ) {
      //   acc += this.makeConditionQuery(keyword, findCondition);
      // } else {
        acc += `${keyword}=${findCondition}`;
      // }
      acc += `&`;
      return acc;
    }, '');
    return queryString;
  }
  static makeConditionQuery(parent: string, condition: any) {
    const conditionOperators = Object.keys(condition);
    const conditionQueryString = conditionOperators.map(cond => {
      return `${parent}__${cond}=${condition[cond]}`;
    });
    return conditionQueryString.join('&');
  }
  static timestampToReadableFormat(timeStamp: Date) {
    const date = new Date(timeStamp);
    const timeString = date.toLocaleTimeString().split(':').splice(0, 2).join(':');
    return `${timeString} ${HelperService.dateString(date)}`;
  }

  static formatDateWithTime(dateValue: any): string {
    return moment(dateValue).format('DD/MM/YYYY HH:mm');
  }

  static isValidDate(date: Date) {
    return (date && date.getTime()) ? true : false;
  }

  static getDateOnly(date: Date) {
    const monthDate = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${year}-${month}-${monthDate.toString().padStart(2, '0')}`;

  }

  static getDateOnlyV1(date: Date) {
    const monthDate = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${year}-${month.toString().padStart(2, '0')}-${monthDate.toString().padStart(2, '0')}`;

  }

  static setCookie(data: any = {}) {
    Object.keys(data).map(key => {
      let value = data[key];
      if (typeof value === 'object') {
        value = JSON.stringify(value);
      }
      document.cookie = `${key}=${value};path=/`;
    });
  }

  static regexString(string) {
    return `${string}$/i`;
  }
  static roundNumber(num) {
    // const roundTwoDecimal = (num) => {
      return Math.round(num * 100) / 100;
    //  };
  }

  static async getOrderDateyUniqueId(uniqueId) {
    if (uniqueId.length !== 19) {
      return null;
    }
    let ts = uniqueId.replace("RD", "");
    if (!Date.parse(ts)) {
      ts = parseInt(ts.toString().split('').reverse().splice(4).reverse().join(''));
      if (!Date.parse(new Date(ts).toString())) {
        return null;
      }
    }
    const date = HelperService.getDateOnlyV1(new Date(ts));
    return date;
  }
  static accessCookie(cookieName) {
          const name = cookieName + '=';
          const allCookieArray = document.cookie.split(';');
          for (let i = 0; i < allCookieArray.length; i++) {
            const temp = allCookieArray[i].trim();
            if (temp.indexOf(name) === 0) {
              return temp.substring(name.length, temp.length);
            }
          }
          return '';
        }

  static dateString(date: any) {
    if (date && Date.parse(date)) {
      return new Date(date).toDateString();
    }
    return 'N/A';
  }

  static getCurrentUrl() {
    return window.location.href;
  }

  static getCurrentPath() {
    return window.location.pathname;
  }

  static removeParam(params: string[] = []) {
    const baseUrl = window.location.origin;
    const pathname = window.location.pathname;
    const routeParams = this.routeParams();
    const filteredParams = Object.keys(routeParams).reduce((acc, param) => {
      if (!params.includes(param)) {
        acc[param] = routeParams[param];
      }
      return acc;
    }, {});
    const queryString = HelperService.queryString(filteredParams);
    return queryString ?
        `${baseUrl}${pathname}?${HelperService.queryString(filteredParams)}` : `${baseUrl}${pathname}`;
  }

  static routeParams(): any {
    return decodeURIComponent(window.location.search.substring(1)).split('&')
      .reduce((acc, keyValue) => {
        const data = keyValue.split('=');
        acc[data[0]] = data[1];
        return acc;
        }, {});
  }
  static getBaseRouteFromUrl(url: string) {
    return url.split('/').splice(0, 3).join('/');
  }

  static minutesToReadableHourMinuteFormat(minutes: number) {
    const date = new Date('1-1-2019');
    date.setMinutes(minutes);
    let readableString = '';
    if (date.getHours()) {
      readableString = `${date.getHours()} hours`;
    }
    if (date.getMinutes()) {
      readableString += ` ${date.getMinutes()} min`;
    }
    return readableString.trim();
  }

  static timeStampToDateOnly(date: Date) {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  static encode(data: string) {
    return btoa(btoa(data));
  }

  static endcodeToLevel(data: string, encodeLevel: any) {
    encodeLevel = parseInt(encodeLevel, 10) || 0;
    for (let i = 0; i < encodeLevel; i++) {
      data = HelperService.encode(data);
    }
    return data;

  }

  static decode(data: string) {
    try {
      return atob(atob(data));
    } catch (err) {
      console.log(err);
      return data;
    }
  }

  static resetTimeTo(date: Date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    return date;
  }

  static redirect(url: string, withReferer = true) {
    const referrer = document.URL;
    const finalUrl = withReferer ? `${url}?referrer=${referrer}` : url;
    window.location.replace(finalUrl);
  }

  static redirectToOldDashboard(relativeRoute, queryParams = {}) {
    const basePath = environment.rapido_dashboard;
    // const token = HelperService.accessCookie('token');
    const queryString = HelperService.queryString(Object.assign({}, queryParams));
    const path = `${basePath}/${relativeRoute}?${queryString}`;
    // const path = `${basePath}/${relativeRoute}?token=${token}`;
    // window.location.replace(path);
    window.open(path, '_blank');
  }

  static redirectToNewPage(url) {
    window.open(url, '_blank');
  }

  // static redirect(url) {
  //   window.location.replace(url);
  // }

  static openInMap(lat, lng) {
    if (lat && lng) {
      const googleUrl = `https://maps.google.com/?q=${lat},${lng}`;
      this.redirectToNewPage(googleUrl);
    }
  }

  static convert24to12hrFormat(time) {
    let timeIn12HrFormat = time;
    let meridian = 'am';
    if (time) {
      const parts = time.split(':');
      if (parts.length === 2) {
        if (parseInt(parts[0], 10)) {
          if (parseInt(parts[0], 10) > 12) {
            parts[0] = parseInt(parts[0], 10) - 12;
            meridian = 'pm';
          } else if (parseInt(parts[0], 10) === 12) {
            meridian = 'pm';
          }
        }
      }
      timeIn12HrFormat = parts.join(':') + ' ' + meridian;
    }
    return timeIn12HrFormat;
  }

  // Numeric timestamp (ms) from tripDate + startTime; falls back to creation date, then 0.
  private static getTripSortTimestamp(order: any, tripStartTimeMap: { [tripId: string]: string }, tripIdKey: string): number {
    const tripId = order.poolData && order.poolData[tripIdKey];
    const tripDate = order.poolData && order.poolData.tripDate;
    const startTime = HelperService.getTripStartTime(tripStartTimeMap, tripId, tripDate);
    const normalizedStartTime = (startTime && startTime !== '-') ? startTime : '00:00';
    if (tripDate) {
      const withTime = moment(`${tripDate} ${normalizedStartTime}`,
        ['YYYY-MM-DD H:mm', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD HH:mm:ss'], true);
      if (withTime.isValid()) { return withTime.valueOf(); }
      const dateOnly = moment(tripDate, 'YYYY-MM-DD', true);
      if (dateOnly.isValid()) { return dateOnly.valueOf(); }
    }
    return order.date ? new Date(order.date).getTime() : 0;
  }

  static tripStartTimeCacheKey(tripId: string, tripDate: string): string {
    return `${tripId}:${tripDate}`;
  }

  static collectUniqueTripIds(orders: any[], tripIdKey: 'hostTripId' | 'guestTripId'): string[] {
    const ids = new Set<string>();
    for (const order of orders) {
      const tripId = order && order.poolData && order.poolData[tripIdKey];
      if (tripId) {
        ids.add(tripId);
      }
    }
    return Array.from(ids);
  }

  static getFirstOrderTripDate(orders: any[]): string | undefined {
    for (const order of orders) {
      const tripDate = order && order.poolData && order.poolData.tripDate;
      if (tripDate) {
        return tripDate;
      }
    }
    return undefined;
  }

  static indexTripsById(trips: any[]): Map<string, any> {
    const map = new Map<string, any>();
    (trips || []).forEach((trip) => {
      const tripId = trip && (trip.id || trip._id);
      if (tripId) {
        map.set(tripId, trip);
      }
    });
    return map;
  }

  static normalizeDayOfWeekFromDate(tripDate: string): string {
    const parsed = moment(tripDate, 'YYYY-MM-DD', true);
    return parsed.isValid() ? parsed.format('dddd').toLowerCase() : '';
  }

  static parseDaySchedules(trip: any): any[] {
    const daySchedules = trip && trip.daySchedules;
    if (!daySchedules) {
      return [];
    }
    if (Array.isArray(daySchedules)) {
      return daySchedules.filter(Boolean);
    }
    if (typeof daySchedules === 'object') {
      return Object.keys(daySchedules).map((day) => ({
        dayOfWeek: day,
        ...daySchedules[day],
      }));
    }
    return [];
  }

  static scheduleForDay(trip: any, tripDate: string): any {
    const day = HelperService.normalizeDayOfWeekFromDate(tripDate);
    if (!day) {
      return null;
    }
    const schedules = HelperService.parseDaySchedules(trip);
    return schedules.find((schedule) =>
      schedule && String(schedule.dayOfWeek || '').toLowerCase() === day
    ) || null;
  }

  static hydrateTripStartTime(trip: any, tripDate: string): string {
    if (!trip) {
      return '-';
    }
    const schedule = HelperService.scheduleForDay(trip, tripDate);
    if (schedule && schedule.startTime) {
      return schedule.startTime;
    }
    if (trip.date === tripDate && trip.startTime) {
      return trip.startTime;
    }
    return trip.startTime || '-';
  }

  static tripFromBulkResponse(response: any, tripId: string, tripDate?: string): any {
    if (!response || !tripId) {
      return null;
    }
    const trips = (response.trip || (response.data && response.data.trip) || []);
    const matched = trips.find((trip: any) => {
      const id = trip && (trip.id || trip._id);
      return id === tripId;
    });
    return HelperService.normalizePoolTripForDisplay(matched, tripDate);
  }

  static normalizePoolTripForDisplay(trip: any, tripDate?: string): any {
    if (!trip) {
      return trip;
    }
    const normalized = { ...trip };
    if (!normalized.routeDetails && Array.isArray(normalized.routes) && normalized.routes[0]) {
      normalized.routeDetails = normalized.routes[0];
    }
    if (tripDate) {
      const startTime = HelperService.hydrateTripStartTime(trip, tripDate);
      if (startTime && startTime !== '-') {
        normalized.startTime = startTime;
      }
      const schedule = HelperService.scheduleForDay(trip, tripDate);
      if (schedule && schedule.startTimeForDayInSeconds) {
        normalized.startTimeForDayInSeconds = schedule.startTimeForDayInSeconds;
      }
    }
    return normalized;
  }

  static hydrateTrips(
    trips: any[],
    orders: any[],
    tripIdKey: 'hostTripId' | 'guestTripId'
  ): { [key: string]: string } {
    const tripsById = HelperService.indexTripsById(trips);
    const tripStartTimeMap: { [key: string]: string } = {};

    for (const order of orders) {
      const poolData = order && order.poolData;
      if (!poolData) {
        continue;
      }
      const tripId = poolData[tripIdKey];
      const tripDate = poolData.tripDate;
      if (!tripId || !tripDate) {
        continue;
      }
      const cacheKey = HelperService.tripStartTimeCacheKey(tripId, tripDate);
      if (tripStartTimeMap[cacheKey]) {
        continue;
      }
      const startTime = HelperService.hydrateTripStartTime(tripsById.get(tripId), tripDate);
      tripStartTimeMap[cacheKey] = startTime;
      if (!tripStartTimeMap[tripId]) {
        tripStartTimeMap[tripId] = startTime;
      }
    }

    return tripStartTimeMap;
  }

  static getTripStartTime(
    tripStartTimeMap: { [key: string]: string },
    tripId?: string,
    tripDate?: string
  ): string {
    if (!tripId) {
      return '-';
    }
    if (tripDate) {
      const keyed = tripStartTimeMap[HelperService.tripStartTimeCacheKey(tripId, tripDate)];
      if (keyed) {
        return keyed;
      }
    }
    return tripStartTimeMap[tripId] || '-';
  }

  static async fetchTripStartTimeMap(
    orders: any[],
    tripIdKey: 'hostTripId' | 'guestTripId',
    getTripsBulk: (ids: string[], date?: string) => Promise<any>
  ): Promise<{ [tripId: string]: string }> {
    const tripIds = HelperService.collectUniqueTripIds(orders, tripIdKey);
    if (tripIds.length === 0) {
      return {};
    }

    const bulkDate = HelperService.getFirstOrderTripDate(orders);
    try {
      const response = await getTripsBulk(tripIds, bulkDate);
      const trips = (response && response.trip) || [];
      return HelperService.hydrateTrips(trips, orders, tripIdKey);
    } catch (e) {
      console.error('Error fetching trips bulk:', e);
      return {};
    }
  }

  // Sorts corporate pool orders by tripDate + startTime (desc). Client-side, current page only.
  static sortByTripDateAndStartTime(
    orders: any[],
    tripStartTimeMap: { [tripId: string]: string },
    tripIdKey: 'hostTripId' | 'guestTripId'
  ): any[] {
    return orders.slice().sort((a, b) => {
      const aTs = HelperService.getTripSortTimestamp(a, tripStartTimeMap, tripIdKey);
      const bTs = HelperService.getTripSortTimestamp(b, tripStartTimeMap, tripIdKey);
      return bTs - aTs;
    });
  }

  // Formats trip date "YYYY-MM-DD" → "ddd, DD MMM YYYY" and 24h start time "HH:mm" → "hh:mm A".
  static formatTripDateTimeDisplay(tripDate: string, startTime: string): { tripDateDisplay: string, startTimeDisplay: string } {
    let tripDateDisplay = '-';
    if (tripDate) {
      const parsed = moment(tripDate, 'YYYY-MM-DD', true);
      tripDateDisplay = parsed.isValid() ? parsed.format('ddd, DD MMM YYYY') : tripDate;
    }

    let startTimeDisplay = '-';
    if (startTime && startTime !== '-') {
      const parsedTime = moment(startTime, ['HH:mm', 'H:mm', 'HH:mm:ss'], true);
      startTimeDisplay = parsedTime.isValid() ? parsedTime.format('hh:mm A') : startTime;
    }

    return { tripDateDisplay, startTimeDisplay };
  }

  static formatPoolDataDisplay(poolData: any): { tripDateDisplay: string, initiatedByDisplay: string } {
    let tripDateDisplay = '-';
    if (poolData && poolData.tripDate) {
      tripDateDisplay = poolData.tripDate;
    }

    let initiatedByDisplay = '-';
    if (poolData && poolData.initiatedBy) {
      const initiatedBy = poolData.initiatedBy;
      initiatedByDisplay = initiatedBy.charAt(0).toUpperCase() + initiatedBy.slice(1);
    }

    return { tripDateDisplay, initiatedByDisplay };
  }

  static extractPoolTripsFromBulkResponse(response: any): any[] {
    if (Array.isArray(response)) {
      return response;
    }
    if (response && Array.isArray(response.data)) {
      return response.data;
    }
    if (response && response.data && Array.isArray(response.data.data)) {
      return response.data.data;
    }
    return [];
  }

  static getOverlapScoreFromPoolTrip(poolTrip: any): { guest?: number, host?: number } | null {
    const score = poolTrip && poolTrip.scoreBreakdown &&
      poolTrip.scoreBreakdown.overlapStrategy &&
      poolTrip.scoreBreakdown.overlapStrategy.score;
    return score || null;
  }

  static buildOverlapScoreMap(poolTrips: any[]): { [orderId: string]: { guest?: number, host?: number } } {
    const overlapScoreMap: { [orderId: string]: { guest?: number, host?: number } } = {};
    if (!Array.isArray(poolTrips)) {
      return overlapScoreMap;
    }
    poolTrips.forEach(poolTrip => {
      const orderId = poolTrip && poolTrip.orderId && String(poolTrip.orderId);
      const score = HelperService.getOverlapScoreFromPoolTrip(poolTrip);
      if (orderId && score) {
        overlapScoreMap[orderId] = score;
      }
    });
    return overlapScoreMap;
  }

  static collectDroppedOrderIds(orders: any[]): string[] {
    const orderIds = (orders || [])
      .filter(order => order && order.status === 'dropped' && order._id)
      .map(order => String(order._id));
    return Array.from(new Set(orderIds));
  }

  static async fetchOverlapScoreMap(
    orders: any[],
    getPoolTripsBulk: (orderIds: string[]) => Promise<any>
  ): Promise<{ [orderId: string]: { guest?: number, host?: number } }> {
    const droppedOrderIds = HelperService.collectDroppedOrderIds(orders);
    if (droppedOrderIds.length === 0) {
      return {};
    }
    try {
      const response = await getPoolTripsBulk(droppedOrderIds);
      return HelperService.buildOverlapScoreMap(HelperService.extractPoolTripsFromBulkResponse(response));
    } catch (e) {
      // Silent failure — table still renders without overlap data
      return {};
    }
  }

  // Formats overlapStrategy.score ratios as "guest : XX%\nhost : YY%".
  static formatOverlapDisplay(overlapScore: { guest?: number, host?: number } | null | undefined): string {
    if (!overlapScore) {
      return '-';
    }
    const toPercent = (value: number | undefined) => {
      if (value === null || value === undefined || isNaN(Number(value))) {
        return '-';
      }
      return Math.round(Number(value) * 100) + '%';
    };
    return 'guest : ' + toPercent(overlapScore.guest) + '\nhost : ' + toPercent(overlapScore.host);
  }

  static buildWalletBalanceCardData(walletBalance: string | null, walletBalanceLoading: boolean, walletBalanceError: boolean): any {
    if (walletBalance === null && !walletBalanceLoading) {
      return null;
    }
    
    let balanceValue = 'N/A';
    let showInr = false;
    
    if (walletBalanceLoading) {
      balanceValue = 'Loading...';
    } else if (walletBalanceError || walletBalance === 'Unable to fetch') {
      balanceValue = 'Unable to fetch';
    } else if (walletBalance) {
      balanceValue = walletBalance;
      showInr = true;
    }
    
    return {
      header: 'Wallet Balance',
      value: balanceValue,
      inr: showInr
    };
  }
}
